export default __webpack_public_path__ + "static/media/thankyou.5dd522d4.png";